// extracted by mini-css-extract-plugin
module.exports = {"App":"App_App__3FyUi","Main":"App_Main__2duKa","Content":"App_Content__yFreb","card":"App_card__1hK3P","FillerImage":"App_FillerImage__1vohH","Image":"App_Image__1aHaC"};